export default "__VITE_ASSET__BYJhnph4__"